var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#6B6A69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52861 5.52858C3.78896 5.26823 4.21107 5.26823 4.47141 5.52858L8.00001 9.05717L11.5286 5.52858C11.789 5.26823 12.2111 5.26823 12.4714 5.52858C12.7318 5.78892 12.7318 6.21103 12.4714 6.47138L8.47141 10.4714C8.21107 10.7317 7.78896 10.7317 7.52861 10.4714L3.52861 6.47138C3.26826 6.21103 3.26826 5.78892 3.52861 5.52858Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.318486fc63a9f59c2fdc594d122356f8.svg";
export { ForwardRef as ReactComponent };